import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ILandingPageLocationProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Sub Heading
	 * @control richtext
	 */
	subHeading?: string;
	/**
	 * CTA Button
	 */
	ctaButton?: ILink;
	/**
	 * Google Maps Embed Link
	 */
	mapLink?: string;
	inverted?: boolean;
}

/**
 * Landing Page Location
 * @icon format-gallery
 * @block
 */
const LandingPageLocation: React.FC<ILandingPageLocationProps> = ({
	id,
	className,
	classNames = [],
	heading,
	subHeading,
	mapLink,
	inverted = false,
}) => (
	<div
		id={id}
		className={
			className ||
			cn(
				'landing-page-location',
				inverted && 'landing-page-location--inverted',
				...classNames,
			)
		}
	>
		<div className="landing-page-location__container container-fluid">
			<div className="row">
				<div
					className="landing-page-location__left col-12 col-lg-6"
					dangerouslySetInnerHTML={{ __html: mapLink }}
				></div>
				<div className="landing-page-location__right col-12 col-lg-6">
					{heading && (
						<h2 className="landing-page-location__heading">
							{heading}
						</h2>
					)}
					{subHeading && subHeading !== '<br>' && (
						<p className="landing-page-location__sub-heading">
							<span
								dangerouslySetInnerHTML={{
									__html: subHeading,
								}}
							/>
						</p>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default LandingPageLocation;
